/* Colour tray preview sort — by hue (colour wheel order) */
(function(){
  var row = document.querySelector('[data-ct-preview]');
  if (!row) return;
  while (row.firstChild) row.removeChild(row.firstChild);
  var mapEl = document.getElementById('ColourHexMap');
  if (!mapEl) return;
  var hexMap;
  try { hexMap = JSON.parse(mapEl.textContent); } catch(e) { return; }
  var section = document.getElementById('ColourTray');
  if (!section) return;
  var curHandle = decodeURIComponent((section.dataset.currentUrl || '').split('/').pop());

  function hueKey(hex) {
    hex = (hex || 'cccccc').replace('#','').toLowerCase();
    var r = parseInt(hex.substr(0,2),16)/255;
    var g = parseInt(hex.substr(2,2),16)/255;
    var b = parseInt(hex.substr(4,2),16)/255;
    var max = Math.max(r,g,b), min = Math.min(r,g,b);
    var h=0, s=0, l=(max+min)/2;
    if (max !== min) {
      var d = max-min;
      s = l>0.5 ? d/(2-max-min) : d/(max+min);
      if (max===r) h=((g-b)/d+(g<b?6:0))/6;
      else if (max===g) h=((b-r)/d+2)/6;
      else h=((r-g)/d+4)/6;
    }
    if (s < 0.10) return 400 + l;
    return h * 360 + l * 0.01;
  }

  var entries = Object.keys(hexMap)
    .filter(function(h) { return h !== curHandle; })
    .map(function(h) { return { handle: h, hex: (hexMap[h]||'cccccc').replace('#','').toLowerCase() }; })
    .sort(function(a,b) { return hueKey(a.hex) - hueKey(b.hex); });
  var frag = document.createDocumentFragment();
  for (var i = 0; i < Math.min(entries.length, 4); i++) {
    var a = document.createElement('a');
    a.href = '/products/' + entries[i].handle;
    a.className = 'ct-swatch';
    a.style.backgroundColor = '#' + entries[i].hex;
    frag.appendChild(a);
  }
  row.appendChild(frag);
})();
